import * as React from 'react';
import { Checkbox, Flex, Modal, theme, Typography } from 'antd';
import { t } from '../../../utils';

const { Text } = Typography;

export const NavigateAwayDialog = props => {
	const [remember, setRemember] = React.useState(false);

	const handleDontShowMsgAgain = () => {
		setRemember(!remember);
	};

	const handleContinue = () => {
		props.onCloseSuccess(remember);
	};
	const { token } = theme.useToken();
	return (
		<Modal
			title=""
			open
			{...props}
			centered
			okText={t('startPage.navigateAwayDialog.continue')}
			onOk={handleContinue}
			onCancel={props.onDismiss}
		>
			<Flex vertical>
				<Text style={{ marginTop: token.marginMD, marginBottom: token.marginSM }}>
					{t('startPage.navigateAwayDialog.moveAwaySelections')}
				</Text>
				<Checkbox
					onChange={handleDontShowMsgAgain}
					style={{ marginBottom: token.marginSM }}
				>
					{t('startPage.navigateAwayDialog.dontShowAgain')}
				</Checkbox>
			</Flex>
		</Modal>
	);
};
